export const ProfessionalAssessmentIcon = ({
  customClassName = '',
  onMouseEnter,
  onMouseLeave
}: {
  customClassName?: string
  onMouseEnter?: () => void
  onMouseLeave?: () => void
}) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClassName}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <path
        d="M22.8806 6.93311C22.8806 5.86548 22.0151 5 20.9475 5H14.0529C12.9853 5 12.1198 5.86548 12.1198 6.93311C12.1198 8.00074 12.9853 8.86623 14.0529 8.86623H20.9475C22.0151 8.86623 22.8806 8.00074 22.8806 6.93311Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.9995 10.0769C29.9994 7.86777 28.2086 6.07697 25.9995 6.07697H24.1862V7.07026C24.1862 8.72711 22.843 10.0703 21.1862 10.0703H13.8132C12.1564 10.0703 10.8132 8.72711 10.8132 7.07026V6.0771H9C6.79086 6.0771 5 7.86796 5 10.0771V27.9999C5 30.209 6.79085 31.9998 8.99997 31.9999L25.9999 32C28.2091 32 30 30.2091 29.9999 27.9999L29.9995 10.0769ZM15.2488 16.2272C15.2488 15.6185 14.7554 15.125 14.1466 15.125H11.0383C10.4296 15.125 9.93616 15.6185 9.93616 16.2272C9.93616 16.8359 10.4296 17.3294 11.0383 17.3294H14.1466C14.7554 17.3294 15.2488 16.8359 15.2488 16.2272ZM9.93616 20.6358C9.93616 20.0271 10.4296 19.5336 11.0383 19.5336H14.1466C14.7554 19.5336 15.2488 20.0271 15.2488 20.6358C15.2488 21.2445 14.7554 21.738 14.1466 21.738H11.0383C10.4296 21.738 9.93616 21.2445 9.93616 20.6358ZM20.1451 20.8988L19.4656 20.1651C19.0409 19.7066 18.3197 19.6942 17.8794 20.1378C17.4594 20.5611 17.4536 21.2422 17.8664 21.6725L19.4219 23.2939C19.8161 23.7049 20.4734 23.7042 20.8667 23.2923L24.7599 19.2153C25.1521 18.8047 25.157 18.1598 24.7712 17.7432C24.352 17.2907 23.6388 17.2832 23.2103 17.7267L20.1451 20.8988ZM9.93616 25.1498C9.93616 24.5411 10.4296 24.0477 11.0383 24.0477H14.1466C14.7554 24.0477 15.2488 24.5411 15.2488 25.1498C15.2488 25.7585 14.7553 26.252 14.1466 26.252H11.0383C10.4296 26.252 9.93616 25.7585 9.93616 25.1498Z"
        fill="currentColor"
      />
    </svg>
  )
}
